import * as React from "react"
import {Box} from "@mui/material";
import {Outlet} from "react-router-dom";

import {AppFavIcon, AppFooter, AppLayout} from "../../@componets";
import {appFavicon, menuSize, showHeader} from "../../@signals";
import {storedMenuSize} from "../../@signals/app";
import {useApp} from "../../@hooks"
import MaximalLayoutHeader from "./header";
import {MaximalLayoutConfig} from "./config";
import MaximalLayoutNav from "./Nav";
import {maximalLayoutMainDesktopStyles, maximalLayoutMainMobileStyles} from "./styles";
import {MENU_SIZE} from "../../@constants";


export default function MaximalLayout({ routes=[], config={}, userData={}, components={}, styles={}, links=[], isLocal=false }) {
    const { isDesktop } = useApp()

    const sxMain = isDesktop ? maximalLayoutMainDesktopStyles() : maximalLayoutMainMobileStyles()

    const handleSetConfig = myConfig => {
        // Pages listed in menu.miniOnLoad always open with the menu collapsed, whatever was remembered
        if (myConfig.menu?.miniOnLoad?.includes(window.location.pathname)) {
            menuSize.value = MENU_SIZE.MINI
            return
        }
        if (storedMenuSize) return
        if ( [MENU_SIZE.EXTENDED, MENU_SIZE.MINI].includes(myConfig.menu?.size || MENU_SIZE.EXTENDED) )
            menuSize.value = myConfig.menu?.size || MENU_SIZE.EXTENDED
    }

    return <AppLayout baseConfig={MaximalLayoutConfig} config={config} userData={userData} onSetConfig={handleSetConfig} isLocal={isLocal}>
        { appFavicon.value && <AppFavIcon icon={appFavicon.value} /> }

        { showHeader.value && <MaximalLayoutHeader headerTools={components.headerTools} sx={styles.header} links={links} /> }

        {/* The header floats over the top of the content, so the content takes the whole screen: the old
            calc(100vh - 42px) left a strip of body grey under every page */}
        <Box className="content" sx={{ display: { lg: 'flex' }, height: '100%', minHeight: '100vh' }}>
            <MaximalLayoutNav routes={routes} sx={styles.menu} />

            <Box component="main" sx={{ ...sxMain, ...styles.main }}>
                <Outlet />
            </Box>
        </Box>
    </AppLayout>
}